<template>
  <div>
    <el-form ref="formData" :model="formData" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_accessories_no') || '辅料编号'"
            prop="accessoriesNo"
          >
            <el-input
              clearable
              v-model="formData.accessoriesNo"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '系统自动生成'
              "
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_accessories_name') || '辅料名称'"
            prop="accessoriesName"
          >
            <el-input
              clearable
              v-model="formData.accessoriesName"
              :placeholder="
                $l('form_label_pe_accessories_name') || '请输入辅料名称'
              "
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_accessories_name_en') || '辅料名称英文'"
            prop="accessoriesNameEn"
          >
            <el-input
              clearable
              v-model="formData.accessoriesNameEn"
              :placeholder="
                $l('form_label_pe_accessories_name_en') || '请输入辅料名称英文'
              "
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_accessories_dict') || '辅料类型'"
            prop="accessoriesDict"
          >
            <dict-select
              clearable
              filterable
              v-model="formData.accessoriesDict"
              url="/master/masterAccessories/packageingSelect"
              :placeholder="
                $l('form_label_select_accessories_dict') || '请选择辅料类型'
              "
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_category_code') || '分类名称'"
            prop="categoryCode"
          >
            <dict-select
              clearable
              filterable
              v-model="formData.categoryCode"
              url="/master/masterCategory/classificationSelect"
              :disabled="true"
            >
            </dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_sup_code') || '供应商'"
            prop="supCode"
          >
            <dict-select
              clearable
              filterable
              v-model="formData.supCode"
              url="/master/masterAccessories/supplierSelect"
              :placeholder="$l('form_label_select_sup_code') || '请选择供应商'"
            >
            </dict-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_unit_price') || '单价'"
            prop="unitPrice"
            size="small"
          >
            <el-input-number
              style="width:100%"
              clearable
              v-model="formData.unitPrice"
              :step="0.01"
              :precision="2"
              :min="0"
              controls-position="right"
              :placeholder="$l('form_label_pe_unit_price') || '请输入单价'"
              size="small"
            >
            </el-input-number>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_moq') || '起定量'"
            prop="moq"
            size="small"
          >
            <el-input-number
              style="width:100%"
              clearable
              v-model="formData.moq"
              :step="1"
              :precision="0"
              :min="0"
              :max="9999999"
              controls-position="right"
              :placeholder="$l('form_label_pe_moq') || '请输入起定量'"
              size="small"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12"> </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_status') || '有效状态'"
            prop="accessoriesStatus"
          >
            <br />
            <el-radio-group v-model="formData.accessoriesStatus">
              <el-radio label="Y">{{
                $l('INDEX.form_label_valid') || '有效'
              }}</el-radio>
              <el-radio label="N">{{
                $l('INDEX.form_label_invalid') || '无效'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_image_code') || '图片上传'"
            prop="imageCode"
            ><br />
            <el-upload
              class="contacts-uploader"
              action="/oss/ossUploadReturnUrlAndFileId"
              :show-file-list="false"
              :data="fileData"
              :headers="fileHeaders"
              :on-success="handleSuccess"
              :before-upload="beforeUpload"
              :disabled="disabled"
            >
              <img
                v-if="formData.imageCode"
                :src="formData.imageCode"
                class="contactsEvent"
              />
              <i v-else class="el-icon-plus contactsEvent-uploader-icon"></i>
            </el-upload>
            <div class="mt-2">
              <span>{{
                $l('form_label_image_code_tip') ||
                  '只能上传jpg/png文件，建议文件大小不超过1.5M'
              }}</span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ this.$l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          this.$l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          this.$l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          this.$l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import util from '@/libs/util'

export default {
  props: {
    disabled: Boolean,
    accessoriesCode: String,
    categoryCode: String,
  },
  components: {},
  data() {
    return {
      backDialogVisible: false,
      formData: {
        accessoriesStatus: 'Y',
        categoryCode: this.categoryCode,
        imageCode: '',
      },
      rules: {
        accessoriesName: [
          {
            required: true,
            message:
              this.$l('form_label_pe_accessories_name') || '请输入辅料名称',
            trigger: 'blur',
          },
        ],
      },
      // 文件上传
      fileData: {
        // abs文件上传参数
        expirationsec: 0,
        fileproperty: 'publicfiles',
      },
      fileHeaders: {
        // 文件上传请求头
        tokenTimeOut: 0,
        token: util.token.getToken(),
      },
    }
  },
  mounted() {
    this.getDate()
    //console.log(this.formData.imageCode)
  },
  methods: {
    getDate() {
      if (!this.accessoriesCode) return
      this.$api
        .masterAccessoriesDetailApi({
          accessoriesCode: this.accessoriesCode,
        })
        .then((res) => {
          this.formData = res.body
          //console.log(this.formData.imageCode)
        })
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return (this.backDialogVisible = false)
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .masterAccessoriesSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    //图片提交的方法
    beforeUpload(file) {
      this.$loading(this.options)
      const isImg = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1.5
      //console.log(file.type)
      if (!isImg) {
        this.$message.warning(
          this.$l('INDEX.tips_image_type') || '上传图片只能是 JPG或PNG 格式!'
        )
      }
      if (!isLt2M) {
        this.$message.warning(
          this.$l('INDEX.tips_image_size') || '上传图片大小不能超过 1.5MB!'
        )
      }
      if (!isImg || !isLt2M) {
        this.$loading(this.options).close()
      }
      return isImg && isLt2M
    },
    handleSuccess(res) {
      if (res.status === 200) {
        this.formData.imageCode = res.body.url
        // 名片OCR
        // this.businessCardUrl(this.formData.contactNameCardUrl1)
        this.$loading(this.options).close()
      }
    },
  },
}
</script>
<!-- 图片文件的格式 -->
<style>
.contacts-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.contacts-uploader .el-upload:hover {
  border-color: #409eff;
}
.contactsEvent-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.contactsEvent {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
